__turbopack_context__.v({
  "locationField": "SecondScreen-module__TpjBoW__locationField",
  "locationFieldWrapper": "SecondScreen-module__TpjBoW__locationFieldWrapper",
});
